import * as Yup from "yup";

import {
  personalInformation,
  temporaryContactInfo,
  firstNationStatus,
  paymentInformation,
} from "./validation";
export const generationFormValidation = Yup.object().shape({
  applicationType: Yup.string().required("Event type is required."),
  PersonalInformation: personalInformation(),
  TemporaryContactInformation: temporaryContactInfo(),
  FirstNationStatus: firstNationStatus(),
  PaymentInformation: paymentInformation(),
});
